export default __webpack_public_path__ + "static/media/file-plus-alt 1.87716afe.svg";